import { render, staticRenderFns } from "./create-personal.vue?vue&type=template&id=5d61c163&scoped=true&"
import script from "./create-personal.vue?vue&type=script&lang=js&"
export * from "./create-personal.vue?vue&type=script&lang=js&"
import style0 from "./create-personal.vue?vue&type=style&index=0&id=5d61c163&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61c163",
  null
  
)

export default component.exports